import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap-5';
import isEmpty from 'lodash/isEmpty';
import isObject from 'lodash/isObject';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons';

import { addChecklistItem, updateChecklistItem, deleteChecklistItem } from '../actions/index';
import RemoteUserSelect from 'components/users/remote_user_select';
import UserSelect from 'components/users/user_select';

export class ChecklistItemForm extends React.Component {
  static propTypes = {
    addChecklistItem: PropTypes.func.isRequired,
    deleteChecklistItem: PropTypes.func.isRequired,
    item: PropTypes.shape({
      assignTo: PropTypes.string,
      customAssignee: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string
      }),
      dueInDays: PropTypes.number,
      id: PropTypes.number,
      listingType: PropTypes.string,
      projectStatus: PropTypes.string,
      taskBody: PropTypes.string,
      taskType: PropTypes.string,
      taskTitle: PropTypes.string
    }),
    limitToUsers: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    })).isRequired,
    listingType: PropTypes.string.isRequired,
    projectStatus: PropTypes.string.isRequired,
    updateChecklistItem: PropTypes.func.isRequired,
    onHide: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props);

    if (this.props.item) {
      this.state = {
        assignTo: this.props.item.assignTo || 'primary_broker',
        body: this.props.item.taskBody || '',
        customAssignee: this.props.item.customAssignee || {},
        deleting: false,
        dueInDays: this.props.item.dueInDays,
        saving: false,
        taskType: this.props.item.taskType || 'other',
        title: this.props.item.taskTitle || ''
      };
    } else {
      this.state = {
        assignTo: this.props.limitToUsers.length > 0 ? 'other_user' : 'primary_broker',
        body: '',
        customAssignee: {},
        deleting: false,
        dueInDays: '',
        saving: false,
        taskType: 'other',
        title: ''
      };
    }
  }

  checklistItemParams = () => {
    return {
      projects_checklist_item: {
        assignTo: this.state.assignTo,
        id: this.props.item ? this.props.item.id : null,
        custom_assignee_id: this.state.customAssignee.id,
        dueInDays: this.state.dueInDays,
        task_type: this.state.taskType,
        task_title: this.state.title,
        task_body: this.state.body,
        listing_type: this.props.item ? this.props.item.listingType : this.props.listingType,
        project_status: this.props.item ? this.props.item.projectStatus : this.props.projectStatus
      }
    };
  }

  canAssignToPrimaryBroker = () => this.props.limitToUsers.length === 0;

  terminateForm = () => {
    this.setState({ saving: false });
    this.props.onHide();
  }

  deleteItem = () => {
    if (this.state.saving || !this.props.item) return;
    this.props.deleteChecklistItem(this.props.item.id).then(this.terminateForm).catch(this.terminateForm);
  }

  handleSave = () => {
    if (this.state.saving) return;

    this.setState({ saving: true });
    if (this.props.item && this.props.item.id) {
      this.props.updateChecklistItem(this.checklistItemParams()).then(this.terminateForm).catch(this.terminateForm);
    } else {
      this.props.addChecklistItem(this.checklistItemParams()).then(this.terminateForm).catch(this.terminateForm);
    }
  }

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  canSave = () => {
    if (this.state.assignTo === 'other_user' && isEmpty(this.state.customAssignee)) return false;
    return this.state.title && !this.state.saving;
  }

  onCustomAssigneeChange = (selection) => {
    this.setState({ customAssignee: { id: isObject(selection) ? selection.value : selection } });
  }

  renderTaskTypeSelect() {
    return (
      <Col md={6} xs={6} >
        <label className="form-label mb-1">
          Task Type
        </label>
        <select
          className="form-select"
          name="taskType"
          value={this.state.taskType}
          onChange={this.handleInputChange}
        >
          <option value="call">Call</option>
          <option value="email">Email</option>
          <option value="other">Other</option>
          <option value="showing">Showing/Tour</option>
          <option value="critical_date">Critical Date</option>
        </select>
      </Col>
    );
  }

  renderDueDateSelect() {
    return (
      <Col md={6} xs={6} >
        <label className="form-label mb-1">
          Due In (Days)
        </label>
        <input
          className="form-control"
          name="dueInDays"
          type="number"
          value={this.state.dueInDays || ''}
          width="2pc"
          onChange={this.handleInputChange}
        />
      </Col>
    );
  }

  renderConfirmDeletionRow() {
    return (
      <div className="text-end">
        <div className="d-inline-block me-3">
          Are you sure you want to delete this item?
        </div>
        <button
          className="btn btn-outline me-3"
          name="cancel-delete"
          onClick={() => this.setState({ deleting: false })}
        >
          Cancel
        </button>
        <button className="btn btn-danger" name="delete" onClick={this.deleteItem}>
          Delete
        </button>
      </div>
    );
  }

  renderDeleteButton() {
    if (!this.props.item) return;
    return (
      <div
        className="btn btn btn-destructive d-inline-block me-3"
        name="remove-task"
        onClick={() => this.setState({ deleting: true })}
      >
        <FontAwesomeIcon icon={faTrashAlt} />
        <span className="ms-2">Delete Task</span>
      </div>
    );
  }

  renderFooterRow() {
    if (this.state.deleting) return this.renderConfirmDeletionRow();
    return (
      <div className="text-end">
        <button className="btn btn-outline me-3" name="cancel" onClick={this.props.onHide}>
          Cancel
        </button>
        {this.renderDeleteButton()}
        <button
          className="btn btn-primary"
          disabled={!this.canSave()}
          name="save"
          onClick={this.handleSave}
        >
          Save
        </button>
      </div>
    );
  }

  defaultCustomAssigneeSelectValue() {
    if (this.state.customAssignee) {
      const { id, name } = this.state.customAssignee;
      return { value: id, label: name };
    } else {
      return null;
    }
  }

  renderUserSelect() {
    if (!this.canAssignToPrimaryBroker()) {
      return (
        <UserSelect
          blankOption={false}
          users={this.props.limitToUsers}
          value={this.state.customAssignee.id}
          onChange={this.onCustomAssigneeChange}
        />
      );
    }

    return (
      <RemoteUserSelect
        defaultValue={this.defaultCustomAssigneeSelectValue()}
        onChange={this.onCustomAssigneeChange}
      />
    );
  }

  render() {
    return (
      <div className="contacts-task-form">
        <Row className="mb-3">
          {this.renderTaskTypeSelect()}
          {this.renderDueDateSelect()}
        </Row>
        <Row className="mb-3">
          <Col className="form-group required">
            <label className="form-label">Task Details</label>
            <input
              className="form-control w-100"
              name="title"
              placeholder="Enter task (required)..."
              required="required"
              type="text"
              value={this.state.title}
              onChange={this.handleInputChange}
            />
          </Col>
        </Row>
        <Row className="mb-3">
          <Col className="form-group">
            <textarea
              className="form-control w-100"
              name="body"
              placeholder="Enter any additional task details..."
              type="text"
              value={this.state.body}
              onChange={this.handleInputChange}
            />
          </Col>
        </Row>
        <Row className="mb-3">
          <Col className="form-group">
            <label className="form-label">Assign To</label>
            {this.canAssignToPrimaryBroker() && (
              <div className="d-flex flex-wrap gap-3">
                <div className="form-check">
                  <input
                    checked={this.state.assignTo === 'primary_broker'}
                    id="assign-to-primary-broker"
                    name="assignTo"
                    type="radio"
                    value="primary_broker"
                    onChange={this.handleInputChange}
                  />
                  <label className="form-check-label" htmlFor="assign-to-primary-broker">
                    Primary Broker
                  </label>
                </div>
                <div className="form-check">
                  <input
                    checked={this.state.assignTo === 'other_user'}
                    id="assign-to-other-user"
                    name="assignTo"
                    type="radio"
                    value="other_user"
                    onChange={this.handleInputChange}
                  />
                  <label className="form-check-label" htmlFor="assign-to-other-user">
                    Specific User
                  </label>
                </div>
              </div>
            )}
            {this.state.assignTo === 'other_user' &&
              <div className="my-3">
                {this.renderUserSelect()}
              </div>
            }
          </Col>
        </Row>
        {this.renderFooterRow()}
      </div>
    );
  }
}

const mapStateToProps = ({ limitToUsers }) => ({ limitToUsers });

export default connect(
  mapStateToProps,
  { addChecklistItem, deleteChecklistItem, updateChecklistItem }
)(ChecklistItemForm);
